// Lead-magnet form → same contact Lambda as #contact, with `type: "checklist"`.
// The Lambda mails the request to info@, who sends the checklist by hand, so
// the confirmation promises a mail rather than an instant download.
export default function initLeadMagnet() {
  const forms = document.querySelectorAll("[data-lead-magnet]")
  if (!forms.length) return

  forms.forEach((form) => {
    const endpoint = form.getAttribute("data-endpoint")
    const button = form.querySelector("[data-lead-submit]")
    const status = form.querySelector("[data-lead-status]")
    const widget = form.querySelector(".cf-turnstile")
    const originalLabel = button ? button.textContent.trim() : "Download de checklist"

    const setStatus = (msg, ok) => {
      if (!status) return
      status.textContent = msg
      status.classList.remove("hidden", "text-emerald-600", "text-red-600")
      status.classList.add(ok ? "text-emerald-600" : "text-red-600")
    }

    form.addEventListener("submit", async (e) => {
      e.preventDefault()
      if (!endpoint || !button) return

      const tokenField = form.querySelector('[name="cf-turnstile-response"]')
      const token = tokenField ? tokenField.value : ""
      if (!token) {
        setStatus("Even de verificatie afronden en opnieuw versturen.", false)
        return
      }

      const data = {
        type: "checklist",
        name: form.elements.name.value,
        email: form.elements.email.value,
        company: form.elements.company ? form.elements.company.value : "",
        "cf-turnstile-response": token,
      }

      button.disabled = true
      button.textContent = "Versturen…"

      try {
        const res = await fetch(endpoint, {
          method: "POST",
          headers: { "content-type": "application/json" },
          body: JSON.stringify(data),
        })
        if (!res.ok) throw new Error("bad status " + res.status)

        form.reset()
        button.textContent = "Aangevraagd ✓"
        button.classList.remove("bg-flame-500", "hover:bg-flame-600")
        button.classList.add("bg-emerald-500")
        setStatus("Bedankt! We mailen je de checklist zo snel mogelijk.", true)
      } catch (_) {
        button.disabled = false
        button.textContent = originalLabel
        setStatus("Er ging iets mis. Probeer het opnieuw of mail info@lekdetectie.online.", false)
      } finally {
        // Turnstile-tokens zijn eenmalig — reset alleen de widget van dit formulier.
        if (window.turnstile && widget) window.turnstile.reset(widget)
      }
    })
  })
}
